export const normalizeProfileAddressValues = (values) => {
  const address = String(values?.address ?? "").trim();

  if (!address) {
    return {
      ...values,
      address: "",
      city: "",
      zipCode: "",
      street: "",
      streetNumber: "",
    };
  }

  return {
    ...values,
    address,
    city: String(values?.city ?? "").trim(),
    zipCode: String(values?.zipCode ?? "").trim(),
  };
};

export const clearProfileAddressFields = (setFieldValue) =>
  Promise.all([
    setFieldValue("address", "", false),
    setFieldValue("city", "", false),
    setFieldValue("zipCode", "", false),
    setFieldValue("street", "", false),
    setFieldValue("streetNumber", "", false),
  ]);
